export enum DealSaleMachineNodes {
  INVESTORS = 'INVESTORS',
  INVESTMENTS = 'INVESTMENTS',
}
